import axios from "axios";
import authService from "../auth/authService";
import { URLS_CONSTANTS } from "../../config.js";
// import Loading from "@/components/loading/Loading.vue";
import errorReport from "@/errorReport.js";
import store from '../store/store';
const actionScope = `loader`;
const ajax = axios.create({
  baseURL: URLS_CONSTANTS.baseURL,
  timeout: 310000
});

const tadbirAjax = axios.create({
  baseURL: "https://94.182.184.165:52615/",
  timeout: 60000
});

const websiteAjax = axios.create({
  baseURL: URLS_CONSTANTS.website_api,
  timeout: 60000
});

ajax.interceptors.request.use(
  async config => {
    if(config.method != "get"){
      if(config.headers['X-Ignore-Modal']){

      }
      else{
        store.dispatch(`${actionScope}/show`);

      }
    }
    let accessToken = await authService.getAccessToken();
    var token = "Bearer" + " " + accessToken;
    config.headers.Authorization = token;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
ajax.interceptors.response.use(
  res => {
    if(res.config.method != "get"){
      store.dispatch(`${actionScope}/hide`);
    }

    if(res.config.headers['X-Ignore-Modal'] || res.config.responseType==="blob"){
    }
    else{
      
      errorReport.showError(res);
    }
    return res;
  },
  async function(error) {
    store.dispatch(`${actionScope}/hide`);
    if (
      error.request.responseType === "blob" &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf("json") != -1
    ) {
      await new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result);
          resolve(Promise.reject(error));
          errorReport.showError(error.response);
        };

        reader.onerror = () => {
          reject(error);
        };
        reader.readAsText(error.response.data);
      }).then(() => {});
    }
    errorReport.showError(error.response);
    return Promise.reject(error);
  }
);

websiteAjax.interceptors.request.use(
  async config => {
    let accessToken = await authService.getAccessToken();
    var token = "Bearer" + " " + accessToken;
    config.headers.Authorization = token;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
export { ajax, tadbirAjax, websiteAjax };

export default {
  install(Vue) {
    Vue.prototype.$ajax = ajax;
  }
};
